
<p-inc-todo-card
    :item = "item"
>
    <template v-slot:comment>
        <div class="card-subtitle primary--text reason-text">
            {{ reasons }}
        </div>
    </template>
</p-inc-todo-card>
